import { CSSProperties } from 'react';

export const deleteProfileButtonContainer: CSSProperties = {
  position: 'fixed',
  bottom: '70px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%'
};

export const deleteProfileButton: CSSProperties = {
  display: 'inline-block',
  color: 'rgba(255, 0, 0, 0.6)'
};
